import { useEffect, useMemo, useState, type ReactNode } from 'react';
import UAParser from 'ua-parser-js';
import styles from './DefaultLayout.module.scss';
import { ForbiddenPage } from '~/components/functional/ForbiddenPage';
import { LoadingContainer } from '~/components/loading/Index';
import { Modal } from '~/components/modals/Index';
import { PcPage } from '~/components/pc/PcPage';
import { useSetRegion } from '~/features/region/hooks/useSetRegion';
import { AuthChecker } from '~/layouts/common/AuthChecker';
import { Meta } from '~/layouts/common/Meta';

interface Props {
  children: ReactNode;
  ogImage?: string;
  ogUrl?: string;
}

export const DefaultLayout = ({ children, ogImage, ogUrl }: Props) => {
  const { isLoading, isForbiddenAccess } = useSetRegion();
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);
  useEffect(() => {
    const parser = new UAParser();
    const device = parser.getDevice().type;
    setIsMobile(device === UAParser.DEVICE.MOBILE || device === UAParser.DEVICE.TABLET);
  }, []);

  const RenderComponent = useMemo(() => {
    if (isMobile === undefined) return <></>;
    if (!isMobile) return <PcPage />;
    return children;
  }, [isMobile]);

  return (
    <>
      <Meta ogImage={ogImage} ogUrl={ogUrl} />
      <div className={styles.wrapper}>
        <LoadingContainer />
        <Modal />
        <AuthChecker>
          {isLoading ? <></> : isForbiddenAccess ? <ForbiddenPage /> : RenderComponent}
        </AuthChecker>
      </div>
    </>
  );
};
